export enum ECMSPage {
	HOME = 'home',
	CONTACT = 'contact',
	LOCATIONS = 'locations',
	MEDIUM_TERM = 'medium-term',
	SHORT_TERM = 'short-term',
	LONG_TERM = 'long-term',
	FAQ = 'faq',
	PRIVACY_POLICY = 'privacy-policy',
	TERMS_OF_SERVICE = 'terms-of-service',
	GENERAL_TERMS_AND_CONDITIONS = 'general-terms-and-conditions',
	DELETE_ACCOUNT = 'delete-account',
	DOCUMENTS = 'documents',
}

export enum ECMSType {
	SUBPAGE = 'subpage',
	CITY = 'city',
}

export enum EHomePageSectionType {
	TESTIMONIALS = 'testimonials',
	ADVANTAGES = 'advantages',
	FEATURES = 'features',
	PARAGRAFS = 'paragrafs',
	ACCORDION = 'accordion',
	TILES = 'tiles',
	BANNERS = 'banners',
}

export enum EContactPageSectionType {
	HEADER = 'header',
}

// export enum ELocationsPageSectionType {
// 	ACCORDION = 'accordion',
// }

export enum ELongTermPageSectionType {
	PARAGRAFS_HEADER = 'paragrafs-header',
	PARAGRAFS = 'paragrafs',
	ACCORDION = 'accordion',
}

export enum EMediumTermPageSectionType {
	PARAGRAFS_HEADER = 'paragrafs-header',
	PARAGRAFS = 'paragrafs',
	ACCORDION = 'accordion',
}

export enum EPageSectionType {
	PAGE_HEADER = 'page-header',
	ACCORDION = 'accordion',
	PARAGRAFS_HEADER = 'paragrafs-header',
	PARAGRAPHS_HEADER = 'paragraphs-header',
	PARAGRAPHS = 'paragraphs',
	PARAGRAFS = 'paragrafs',
	BRANCHES = 'branches',
	OTHER_LOCATIONS = 'other-locations',
	META = 'meta',
	PAGE_HEADER_IMAGE = 'page-header-image',
	CONTENT_SECTION = 'content-section',
	FAQ = 'faq',
	FAQ_GROUPS = 'faq-groups',
}

export enum ELocationSectionType {
	PAGE_HEADER_IMAGE = 'page-header-image',
	MAP_SECTION = 'map-section',
	TESTIMONIALS = 'testimonials',
	CONTENT_SECTION_1 = 'content-section-1',
	CONTENT_SECTION_2 = 'content-section-2',
	CONTENT_SECTION_2_IMAGE = 'content-section-2-image',
	FAQ_SECTION = 'faq-section',
	META = 'meta',
	STRUCTURAL_DATA = 'structural-data',
}

export enum ECMSLocationTabName {
	MAIN = 'main',
	BRANCHES = 'branches',
	LOCATIONS = 'locations',
}

export enum ELocationType {
	BRANCH = 'branch',
	LOCATION = 'location',
}

export enum ELocationSwitchType {
	OTHER_LOCATIONS = 'other-locations',
	DELIVERY_BUSES = 'delivery-buses',
	PASSENGER_BUSES = 'passenger-buses',
}
